var React = require('react');

function Tracking (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","opacity":".4","stroke":"#333","strokeMiterlimit":"10","strokeWidth":".86"},React.createElement("path",{"d":"M26.74 1.75v16.5M19.99 1.75v16.5M14.82 1.75v16.5M10.85 1.75v16.5M7.81 1.75v16.5M5.48 1.75v16.5M3.69 1.75v16.5M2.32 1.75v16.5M1.26 1.75v16.5"})));
}

Tracking.defaultProps = {"id":"Layer_1","viewBox":"0 0 28 20"};

module.exports = Tracking;

Tracking.default = Tracking;
